export default __webpack_public_path__ + "static/media/wsjtj.8a927d7f.png";